// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__rGnnr","active":"NavigationItem_active__31r5N"};